import { FILE_STATES } from '../constants';

export const prepareFiles = (fileList, fileType) => {
  const preparedFiles = [];
  for (let i = 0; i < fileList.length; i += 1) {
    const currentFile = fileList[i];
    const isImage = currentFile.type.includes('image');
    const src = URL.createObjectURL(currentFile);
    preparedFiles.push({
      type: fileType,
      data: currentFile,
      src,
      isImage,
      meta: {
        name: currentFile.name,
        size: currentFile.size,
        type: currentFile.type,
      },
    });
  }
  return preparedFiles;
};

export const clearFileUrls = (files = []) => {
  files.forEach((f) => {
    URL.revokeObjectURL(f.src);
  });
};

export const validateFiles = (files, constraints, onError) => {
  // onError = (file, errorText) => { ... }
  const { maxSize = Infinity, validMimeTypes = [''] } = constraints;
  const errorFiles = [];
  files.forEach((f) => {
    const isFileValidType = validMimeTypes.some((type) => f.data.type.includes(type));
    if (!isFileValidType) {
      onError(f, 'validationErrors.fileWrongType');
      errorFiles.push('validationErrors.fileWrongType');
      return;
    }

    const isFileValidSize = f.data.size < maxSize;
    if (!isFileValidSize) {
      onError(f, 'validationErrors.fileMaxSize');
      errorFiles.push('validationErrors.fileMaxSize');
    }
  });

  return errorFiles;
};

export const getValidationRules = (data, attachmentConstraints, fieldRule) => {
  const { isOtherApplicant, isOtherPaymentReceiver } = data;

  return isOtherPaymentReceiver || isOtherApplicant
    ? {
      ...attachmentConstraints,
      requiredTypes: attachmentConstraints.requiredTypes.concat(fieldRule),
    }
    : attachmentConstraints;
};

export const VALIDATION_ERRORS = {
  EMPTY: {
    type: 'EMPTY',
    message: 'validationErrors.fileRequired',
  },
  SOME_INVALID: {
    type: 'SOME_INVALID',
    message: 'validationErrors.someFilesInvalid',
  },
  MAX_NUMBER_EXCEEDED: {
    type: 'MAX_NUMBER_EXCEEDED',
    message: 'validationErrors.fileNumberExceeded',
  },
};

export const validator = (data, rules = {}) => {
  const errors = {};
  const counter = {};

  const {
    requiredTypes = [],
    maxNumberLimits = {},
  } = rules;

  requiredTypes.forEach((type) => {
    errors[type] = VALIDATION_ERRORS.EMPTY;
  });

  const { files, fileStates } = data;
  files.forEach((f) => {
    const fileState = fileStates[f.src];

    if (
      errors[f.type]
        && errors[f.type].type === VALIDATION_ERRORS.EMPTY.type
    ) {
      errors[f.type] = null;
    }

    counter[f.type] = counter[f.type] ? (counter[f.type] + 1) : 1;
    if (
      maxNumberLimits[f.type]
        && counter[f.type] > maxNumberLimits[f.type]
    ) {
      errors[f.type] = VALIDATION_ERRORS.MAX_NUMBER_EXCEEDED;
    }

    if (
      fileState === FILE_STATES.INVALID
    ) {
      errors[f.type] = VALIDATION_ERRORS.SOME_INVALID;
    }
  });

  return errors;
};
